import { useEffect, useState } from 'react'
import { EmogiCount, parseUnicode } from '../../../../models/commonModels'
import styles from './ReactionPreview.module.css'
import { Flex, Result } from 'antd'
export const ReactionPreview = ({reactions}:{reactions:EmogiCount[]}) =>{
// const [result,setResult] = useState<string[][]>([])
//     useEffect(()=>{
        
//         const distinctArr = removeDups(reactions);
        
//         distinctArr.forEach((item)=>{
//             var a = [];
//             for(var i=0;i<reactions.filter((i)=> i==item).length; i++){
//                 a.push(item)
//             }
//             var c:string[][] = result;
//             c.push(a)
//             setResult(c)
//         })
//         console.log(result)
//     },[])

//     function removeDups<T>(names: T[]): T[] {
//         let unique: Map<T, boolean> = new Map();
//         names.forEach(function(i) {
//             if(!unique.has(i)) {
//             unique.set(i, true);
//             }
//         });
//         return Array.from(unique.keys());
//     }
    
    return(
        <div style={{display:"inline-block"}}>
            <div style={{display:"flex", flexDirection:"row", gap:"10px", flexWrap:"wrap", marginTop:"10px"}}>
                {reactions.map((item)=>{
                    return <div className={styles.reaction_preview_container}>
                        <div className={styles.reaction_preview_view}>
                                <div>{parseUnicode(item.emoji)}</div>
                        </div>
                        <div className={styles.reaction_preview_count}>{item.count}</div>
                    </div>
                })}
                {/* <div className={styles.reaction_preview_view}>
                    {reactions.map((item)=>{return <div>{parseUnicode(item)}</div>})}
                </div>
                <div className={styles.reaction_preview_count}>{reactions.length}</div> */}
            </div>
        </div>
        
    )
}